import { useState } from "react";
import { ImportScreen } from "./components/ImportScreen";
import { ReviewScreen } from "./components/ReviewScreen";
import { AuditScreen } from "./components/AuditScreen";
import { DiscoverScreen } from "./components/DiscoverScreen";

type Tab = "import" | "discover" | "review" | "audit";

export function App() {
  const [tab, setTab] = useState<Tab>("import");

  return (
    <>
      <header>
        <h1>SoruLab Backoffice</h1>
        <nav>
          <button className={tab === "import" ? "active" : ""} onClick={() => setTab("import")}>
            Import
          </button>
          <button className={tab === "discover" ? "active" : ""} onClick={() => setTab("discover")}>
            Discover
          </button>
          <button className={tab === "review" ? "active" : ""} onClick={() => setTab("review")}>
            Review
          </button>
          <button className={tab === "audit" ? "active" : ""} onClick={() => setTab("audit")}>
            Audit log
          </button>
        </nav>
      </header>
      <main>
        {tab === "import" && <ImportScreen />}
        {tab === "discover" && <DiscoverScreen />}
        {tab === "review" && <ReviewScreen />}
        {tab === "audit" && <AuditScreen />}
      </main>
    </>
  );
}
